module.exports = __webpack_public_path__ + "img/flytoget-white.bc485b2d.svg";